<template>
  <div class="index-container">
    <el-form :inline="false">
      <el-form-item label="选择店铺"
        ><tenantSelector ref="tenantSelector" v-model="tenant"
      /></el-form-item>
      <el-form-item v-if="tenant && tenant.Key" label="店铺名称：">{{
        tenant.Name
      }}</el-form-item>
      <el-form-item v-if="tenant && tenant.Key" label="授权状态：">
        <el-tag v-if="tenant.Status == 10" type="success">{{
          format.tenantStatusFormat(tenant.Status)
        }}</el-tag>
        <el-tag v-else type="danger">{{
          format.tenantStatusFormat(tenant.Status)
        }}</el-tag>
      </el-form-item>
      <el-form-item v-if="tenant && tenant.Key" label="授权令牌：">{{
        tenant.Token
      }}</el-form-item>
      <el-form-item v-if="tenant && tenant.Key" label="过期时间：">{{
        format.dateTimeFormat(tenant.TokenExpire)
      }}</el-form-item>
    </el-form>
    <el-button
      v-if="tenant.Key && tenant.LeftRefreshCount > 0"
      type="warning"
      icon="el-icon-refresh-left"
      size="small"
      @click="handleRefresh()"
      >刷新授权</el-button
    >
    <el-button
      type="success"
      v-if="tenant.Key && tenant.Status != 10"
      @click="handleAuth"
      >店鋪授权</el-button
    >
  </div>
</template>
<script>
import { getToken } from "@/api/setting/tenant";
import tenantSelector from "@/components/tenantSelector.vue";
export default {
  components: { tenantSelector },
  data() {
    return {
      shopCode: "",
      authCode: "",
      tenant: { Key: "", Name: "", Status: 0, Token: "", TokenExpire: "" },
    };
  },
  methods: {
    handleAuth() {
      let url = `https://e.dianping.com/dz-open/merchant/auth?app_key=${this.tenant.AppKey}&state=${this.tenant.Code}&redirect_url=https://meijia.codetime.com.cn/auth.html`;
      window.open(url);
    },
    handleRefresh() {
      this.$confirm("确认刷新店铺授权吗？", "提示", {}).then(() => {
        let parma = { key: tenant.Key };
        refreshToken(parma).then(res);
        {
          if (res) {
            this.tenant = res;
          }
        }
      });
    },
  },
  mounted() {
    if (this.$route.query.auth_code) {
      this.authCode = this.$route.query.auth_code;
    }
    if (this.$route.query.state) {
      this.shopCode = this.$route.query.state;
    }
    if (this.authCode && this.shopCode) {
      let prama = {
        authCode: this.authCode,
        shopCode: this.shopCode,
      };
      getToken(prama).then((res) => {
        if (res) {
          this.tenant = res;
        }
      });
    }
  },
};
</script>
  <style lang='scss' scoped>
.tip {
  font-size: larger;
  font-weight: bolder;
  color: red;
}

/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  height: 1px;
}
.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  .item {
    flex: 1;
    padding: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    span {
      margin-left: 20px;
      font-size: 20px;
    }
  }
}
.chart {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .item {
    flex: 1;
  }
}
.index-container {
  font-size: 20px;
  .content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    .box {
      margin-top: 20px;
      background: white;
    }

    .panel {
      background: white;
      border-radius: 5px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 40px 60px;
      box-sizing: border-box;
      .iconfont {
        font-size: 80px;
        margin-right: 100px;
      }
      .name {
        margin-bottom: 20px;
        font-size: 25px;
      }
      .count {
        font-size: 40px;
        font-weight: bold;
        text-align: right;
      }
    }
  }
}
</style>